import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Box,
  GDSStyleObject,
  FormField,
  TextInput,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../../assets/json/COB_QUESTIONER.json';
import { Calendar } from '../../../reusable-components/calendar/calendar';
// import useCobStore from '../../../store/cob-store';
import './details.css';
import {
  isEmpty,
  isNotEmpty,
  compareTwoDate,
  isNoSpace,
  isAlphaNumberic,
  // isNumberOnly,
  // isAlphaNumbericPlusSpace,
} from '../../../helpers/helpers';
import useCobStore from '../../../../store/cob-store';
import { COBLayout } from '../../../cob-layout/cob-layout';

export const InsuranceDetails = forwardRef((props: any, ref) => {
  // export function InsuranceDetails(props: any) {
  const { errorHandling, nextButtonClicked, OPISResponseInfo } = props;
  const is360 = useMediaQuery(queryHelpers.down(390));

  const [endDateError, setEndDateError] = useState<string>('');
  const [isEndDateSelected, setEndDateSelected] = useState<boolean>(false);

  const [effectiveDateError, setEffectiveDateError] = useState<string>('');
  const [isEffectiveDateSelected, setEffetiveDateSelected] =
    useState<boolean>(false);

  const cobResponse = useCobStore((state: any) => state.cobInformation);
  // const updateCobInfo = useCobStore((state: any) => state.updateCobInfo);
  const dependantList = useCobStore((state: any) => state.demographics);

  const [form, setForm] = useState({
    insuranceCarrier: OPISResponseInfo?.insuranceCarrier
      ? OPISResponseInfo?.insuranceCarrier
      : '',
    policyNumber: OPISResponseInfo?.policyNumber
      ? OPISResponseInfo?.policyNumber
      : '',
    groupNumber: OPISResponseInfo?.groupNumber
      ? OPISResponseInfo?.groupNumber
      : '',
    effectiveDate: OPISResponseInfo?.effectiveDate
      ? OPISResponseInfo?.effectiveDate
      : '',
    cancelDate: OPISResponseInfo?.cancelDate
      ? OPISResponseInfo?.cancelDate
      : '',
  });

  const [errors, setErrors] = useState({
    insuranceCarrier: false,
    policyNumber: false,
    groupNumber: false,
    effectiveDate: false,
    cancelDate: false,
  });

  const formField =
    isEmpty(form.insuranceCarrier) ||
    (isEndDateSelected && isEmpty(form.cancelDate)) ||
    (isEffectiveDateSelected && isEmpty(form.effectiveDate)) ||
    compareTwoDate(form.effectiveDate, form.cancelDate);

  const isValid =
    isNotEmpty(form.insuranceCarrier) &&
    isEffectiveDateSelected &&
    isEmpty(form.effectiveDate) &&
    isEndDateSelected &&
    isEmpty(form.cancelDate) &&
    !compareTwoDate(form.effectiveDate, form.cancelDate);

  const updatePolicyDetail = () => {
    const filterInfo = cobResponse.additionalInsurance.filter(
      (memberDetail: any) =>
        memberDetail.member.firstName === OPISResponseInfo.member?.firstName &&
        memberDetail.member.lastName === OPISResponseInfo.member?.lastName,
    );
    return filterInfo[0];
  };

  const onUpdateField = (event: any) => {
    const { value, id } = event.target ? event.target : event;
    // if(!compareTwoDate(form.effectiveDate, form.cancelDate)) {
    //   errors.cancelDate = true;
    //   formField = false;
    // }
    const nextFormState = {
      ...form,
      [id]: value,
    };
    setForm(nextFormState);
    if (id === 'insuranceCarrier') {
      setForm((prevState) => ({
        ...prevState,
        insuranceCarrier: isNoSpace(value) ? '' : value.replace(/^\s+/g, ''),
      }));
    }
    if (id === 'policyNumber') {
      setForm((prevState) => ({
        ...prevState,
        policyNumber: isNoSpace(value) ? '' : isAlphaNumberic(value),
      }));
    }
    if (id === 'groupNumber') {
      setForm((prevState) => ({
        ...prevState,
        groupNumber: isNoSpace(value) ? '' : isAlphaNumberic(value),
      }));
    }
    // updateCobInfo(...cobResponse, ...nextFormState)

    const policyUpdate = updatePolicyDetail();
    if (policyUpdate !== undefined) {
      policyUpdate.insuranceCarrier = nextFormState.insuranceCarrier;
      policyUpdate.policyNumber = nextFormState.policyNumber;
      policyUpdate.groupNumber = nextFormState.groupNumber;
      policyUpdate.effectiveDate = nextFormState.effectiveDate;
      policyUpdate.cancelDate = nextFormState.cancelDate;
    }
    // Object.assign(OPISResponseInfo, nextFormState);

    // updateCobInfo(OPISResponseInfo);

    setErrors({
      ...errors,
      [id]: isEmpty(value.trim()),
    });
  };

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          insuranceCarrier: isEmpty(form.insuranceCarrier),
          policyNumber: false,
          groupNumber: false,
          effectiveDate: isEffectiveDateSelected && isEmpty(form.effectiveDate),
          cancelDate:
            compareTwoDate(form.effectiveDate, form.cancelDate) &&
            isEndDateSelected &&
            isEmpty(form.cancelDate),
        });
      }
    }
  }, [
    nextButtonClicked,
    isValid,
    form.insuranceCarrier,
    form.groupNumber,
    form.effectiveDate,
    form.cancelDate,
    form.policyNumber,
    isEffectiveDateSelected,
    isEndDateSelected,
    errorHandling,
  ]);

  useEffect(() => {
    if (
      formField ||
      (errors.insuranceCarrier &&
        errors.groupNumber &&
        errors.cancelDate &&
        errors.effectiveDate &&
        errors.policyNumber)
    ) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [
    formField,
    errorHandling,
    form,
    errors,
    OPISResponseInfo,
    isEffectiveDateSelected,
    isEndDateSelected,
  ]);

  const selectedStartDate = (startDate: string) => {
    // setForm({effectiveDate: form.effectiveDate });
    onUpdateField({ value: startDate, id: 'effectiveDate' });
  };

  // const selectedEndDate = (cancelDate: string) => {
  //   // form.effectiveDate = cancelDate;
  //   onUpdateField({ value: cancelDate, id: 'cancelDate' });
  // };

  const otherCancelDate = (selectedCancelDate: string) => {
    setForm((prevState) => ({
      ...prevState,
      cancelDate: selectedCancelDate,
    }));
    form.cancelDate = selectedCancelDate;
    OPISResponseInfo.cancelDate = selectedCancelDate;
    setErrors((prevState) => ({
      ...prevState,
      cancelDate: !selectedCancelDate,
    }));
  };

  useImperativeHandle(ref, () => ({
    callValidation() {
      if (
        isEmpty(form.effectiveDate || OPISResponseInfo.effectiveDate) &&
        isEffectiveDateSelected
      ) {
        setEffectiveDateError(COBQuestioner.COB.ERRORS.VALIDDATE);
        setErrors((prevState) => ({
          ...prevState,
          effectiveDate: true,
        }));
      } else {
        setEffectiveDateError('');
        setErrors((prevState) => ({
          ...prevState,
          effectiveDate: false,
        }));
      }

      if (isEndDateSelected || form.cancelDate) {
        if (isEmpty(form.cancelDate || OPISResponseInfo.cancelDate)) {
          setEndDateError(COBQuestioner.COB.ERRORS.VALIDDATE);
          setErrors((prevState) => ({
            ...prevState,
            cancelDate: true,
          }));
        } else if (compareTwoDate(form.effectiveDate, form.cancelDate)) {
          setEndDateError(COBQuestioner.COB.ERRORS.CANCELDATE);
          setErrors((prevState) => ({
            ...prevState,
            cancelDate: true,
          }));
        } else {
          setEndDateError('');
          setErrors((prevState) => ({
            ...prevState,
            cancelDate: false,
          }));
        }
      }
    },
  }));

  return (
    <COBLayout
      title={
        OPISResponseInfo?.member?.firstName ===
          dependantList.demographics?.firstName &&
        OPISResponseInfo.member?.dateOfBirth ===
          dependantList?.demographics?.dateOfBirth
          ? COBQuestioner.COB.INFORMATION.YOUROTHERINSURANCE
          : `${`${OPISResponseInfo.member.firstName} ${OPISResponseInfo.member.lastName}${COBQuestioner.COB.INFORMATION.DEPENDENTOTHERINSURANCE}`}`
      }
      dataTestId="insurance-detail"
      questionTitle={
        <>
          {COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.TITLE}{' '}
          {OPISResponseInfo?.member?.firstName ===
          dependantList.demographics?.firstName
            ? COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY
                .YOUROTHERINSURANCE
            : `${`${OPISResponseInfo.member.firstName}${COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.DEPENDENTOTHERINSURANCE}`}`}
        </>
      }
      disclaimer={COBQuestioner.COB.QUESTIONS.REQUIREDDISCLAIMER}
      isDependant={false}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
          } as GDSStyleObject
        }
      >
        <FormField
          id="insuranceCarrier"
          label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY
              .INSURANCECOMPANY
          }
          statusIconLabel="Error"
          inputStatus={errors.insuranceCarrier ? 'error' : undefined}
          statusMessage={
            errors.insuranceCarrier
              ? COBQuestioner.COB.ERRORS.INSURANCECARRIER
              : ''
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <TextInput
            required
            value={form?.insuranceCarrier}
            maxLength={35}
            onChange={onUpdateField}
            placeholder={
              COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.PLACEHOLDER
                .INSURANCECOMPANY
            }
            data-testid="carrier"
          />
        </FormField>
        <FormField
          id="policyNumber"
          label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.POLICYNUMBER
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <TextInput
            value={`${form?.policyNumber}`}
            maxLength={17}
            onChange={onUpdateField}
            placeholder={
              COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.PLACEHOLDER
                .POLICYNUMBER
            }
          />
        </FormField>
        <FormField
          id="groupNumber"
          label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.GROUPNUMBER
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <TextInput
            value={`${form?.groupNumber}`}
            maxLength={30}
            onChange={onUpdateField}
            placeholder={
              COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.PLACEHOLDER
                .GROUPNUMBER
            }
          />
        </FormField>
        <FormField
          id="effectiveDate"
          label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.EFFECTIVEDATE
          }
          aria-label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.EFFECTIVEDATE
          }
          css={
            {
              marginBottom: '$one',
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <Calendar
            selectedFormatDate={selectedStartDate}
            currentDate={`${OPISResponseInfo?.effectiveDate}`}
            setWidth={`${!is360 ? '116px' : '104px'}`}
            showError={errors.effectiveDate}
            errorMessage={effectiveDateError}
            selectedDataValue={(val: any) => setEffetiveDateSelected(val)}
          />
        </FormField>
        <FormField
          id="cancelDate"
          label={COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.ENDDATE}
          aria-label={
            COBQuestioner.COB.QUESTIONS.CONTROLS.INSURANCEPOLICY.ENDDATE
          }
          css={
            {
              '& label': {
                marginBottom: '10px',
              },
            } as GDSStyleObject
          }
        >
          <Calendar
            selectedFormatDate={otherCancelDate}
            currentDate={`${OPISResponseInfo?.cancelDate}`}
            setWidth={`${!is360 ? '116px' : '104px'}`}
            showError={errors.cancelDate}
            errorMessage={endDateError}
            selectedDataValue={(val: any) => setEndDateSelected(val)}
          />
        </FormField>
      </Box>
    </COBLayout>
  );
});
